import { render, staticRenderFns } from "./SettingsIcon.vue?vue&type=template&id=71e0a704&scoped=true&"
import script from "./SettingsIcon.vue?vue&type=script&lang=js&"
export * from "./SettingsIcon.vue?vue&type=script&lang=js&"
import style0 from "./SettingsIcon.vue?vue&type=style&index=0&id=71e0a704&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e0a704",
  null
  
)

export default component.exports